import * as React from "react";
import { Tooltip } from "react-bootstrap";
import I18n, { PrefixedKeys } from "lib/I18n";

function createTooltip(
  messageKey: PrefixedKeys<"bigquery_table_viewer.label.">,
) {
  return (
    <Tooltip id={`tooltip_${messageKey}`}>
      {I18n.t(`bigquery_table_viewer.label.${messageKey}`)}
    </Tooltip>
  );
}

export const tooltips: { [index: string]: JSX.Element } = {
  move_to_event_master: createTooltip("move_to_event_master"),
  event_master_not_found: createTooltip("event_master_not_found"),
  show_ddl: createTooltip("show_ddl"),
  delete_table: createTooltip("delete_table"),
};
